import { ExterneOrganisation } from 'fobclient/lib/entity'
import FieldsGeneric from './FieldsGeneric'
let Fields = FieldsGeneric('ExterneOrganisation')

export default {
  label: 'Externe Organisation',
  route: 'externeorganisation',
  class: ExterneOrganisation,
  className: 'externeOrganisation',
  preliminaryStringRep (data) {
    return `${data.name}, ${data.stadt}`
  },
  fields: [
    {
      label: 'ExterneOrganisation.form.name',
      field: 'name',
      type: 'string',
      table: true
    },
    {
      label: 'ExterneOrganisation.form.stadt',
      field: 'stadt',
      type: 'string',
      table: true
    },
    {
      label: 'ExterneOrganisation.form.beschreibung',
      field: 'beschreibung',
      type: 'string'
    },
    {
      label: 'ExterneOrganisation.form.kurzname',
      field: 'kurzname',
      type: 'string'
    },
    {
      ...Fields.PrefetchedSingleReference(
        'land',
        'land',
        'globe'
      ),
      preselect: (land) => land.nameDE === 'Deutschland',
      prefilter: (land) => land.alpha2code !== 'EP',
      orderBy: 'nameDE'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/schema/ExterneOrganisation.js